export enum DialogResult {
  yes = 1,
  no = 2,
  cancel = 3
}